import 'react';
import CommonMeta from './CommonMeta';
import ExperienceMeta from './ExperienceMeta';
import WebProfileMeta from './WebProfileMeta';

const Meta = () => (
  <>
    <CommonMeta />
    <WebProfileMeta />
    <ExperienceMeta />
  </>
);

export default Meta;
